import * as React from 'preact/compat'
import SeriesTableRenderer from './SeriesTableRenderer'
import styles from '../../../css/game-series-scheme.pcss.json'
import SeriesCards from './SeriesCards'
import LinesRenderer from './LinesRenderer'
import { type ISeriesSchemeState, SeriesSchemeState } from './state'
import GamesPositioner from './GamesPositioner'
import { useEffect } from 'preact/compat'

export interface Coords {
  x: number,
  y: number
}

interface PropTypes {
  editable: boolean,
  recenter: () => void
}

export default ({ recenter }: PropTypes) => {
  const context = React.useContext<ISeriesSchemeState>(SeriesSchemeState)

  if (!context.games.value || !context.gameElements.value) {
    return null
  }

  const { toRender, roots } = React.useMemo(() => {
    return new GamesPositioner(context.games.value, context.gamesRelations.value).processGames()
  }, [context.games.value, context.gamesRelations.value])

  useEffect(() => {
    context.renderLines.value = true
  }, [])

  return <div className={styles['schemeContainer']} ref={context.storeContainer}>
    <SeriesCards/>
    <div className={styles['tablesContainer']}>
      {toRender.map(batch => <SeriesTableRenderer gamesInfo={batch}/>)}
    </div>
    {context.renderLines.value && <LinesRenderer roots={roots} recenter={recenter} />}
  </div>
}
